import LessonPage from "../../../../components/LessonPage";

export default function GhoranPage() {
  const sections = [
    {
      label: "درس ۱",
      points: 120,
      items: [
        { title: "درس 1", icon: "📘", link: "/classroom/class1/ghoran/lesson1/review1", image: "/img1.png" },
        { title: "تمرین", icon: "📘", link: "/classroom/class1/ghoran/lesson1/review2", image: "/img2.png" },
        
      ],
    },
    {
      label: "درس ۲",
      points: 90,
      items: [
        { title: "درس 2", icon: "📘", link: "/classroom/class1/ghoran/lesson1/review3", image: "/img1.png" },
        { title: "تمرین", icon: "📘", link: "/classroom/class1/ghoran/lesson1/review4", image: "/img1.png" },
        
      ],
    },
    {
      label: "درس 3",
      points: 90,
      items: [
        { title: "درس 3", icon: "📘", link: "/classroom/class1/ghoran/lesson1/review5", image: "/img2.png" },
        { title: "تمرین", icon: "📘", link: "/classroom/class1/ghoran/lesson1/review6", image: "/img1.png" },
        
      ],
    },
    {
      label: "درس 4",
      points: 90,
      items: [
        { title: "درس 4", icon: "📘", link: "/classroom/class1/ghoran/lesson1/review7", image: "/img1.png" },
        { title: "تمرین", icon: "📘", link: "/classroom/class1/ghoran/lesson1/review8", image: "/img2.png" },
        
      ],
    },
    {
      label: "درس 5",
      points: 90,
      items: [
        { title: "درس 5", icon: "📘", link: "/classroom/class1/ghoran/lesson1/review9", image: "/img1.png" },
        { title: "تمرین", icon: "📘", link: "/classroom/class1/ghoran/lesson1/review10", image: "/img1.png" },
        
      ],
    },
    {
      label: "درس 6",
      points: 90,
      items: [
        { title: "درس 6", icon: "📘", link: "/classroom/class1/ghoran/lesson1/review11", image: "/img2.png" },
        { title: "تمرین", icon: "📘", link: "/classroom/class1/ghoran/lesson1/review12", image: "/img1.png" },
        
      ],
    },
    {
      label: "درس 7",
      points: 90,
      items: [
        { title: "درس 7", icon: "📘", link: "/classroom/class1/ghoran/lesson1/review13", image: "/img1.png" },
        { title: "تمرین", icon: "📘", link: "/classroom/class1/ghoran/lesson1/review14", image: "/img2.png" },
      ],
    },
    {
      label: "درس 8",
      points: 90,
      items: [
        { title: "درس 8", icon: "📘", link: "/classroom/class1/ghoran/lesson1/review15", image: "/img1.png" },
        { title: "تمرین", icon: "📘", link: "/classroom/class1/ghoran/lesson1/review16", image: "/img2.png" },
      ],
    },
  ];

  return (
    <LessonPage
      title="قران کلاس اول"
      sections={sections}
      onClose={() => window.history.back()}
    />
  );
}